<template>
  <div class="editor form-group">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 2.66699H9.33333C10.0406 2.66699 10.7189 2.94794 11.219 3.44804C11.719 3.94814 12 4.62641 12 5.33366C12 6.0409 11.719 6.71918 11.219 7.21928C10.7189 7.71937 10.0406 8.00033 9.33333 8.00033H4V2.66699Z"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 8H10C10.7072 8 11.3855 8.28095 11.8856 8.78105C12.3857 9.28115 12.6667 9.95942 12.6667 10.6667C12.6667 11.3739 12.3857 12.0522 11.8856 12.5523C11.3855 13.0524 10.7072 13.3333 10 13.3333H4V8Z"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6665 2.66699H6.6665"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.33325 13.334H3.33325"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 2.66699L6 13.3337"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.6667 8L2.00008 8"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.3333 3.33301H6.33333C5.71449 3.33301 5.121 3.57884 4.68342 4.01643C4.24583 4.45401 4 5.0475 4 5.66634C4 6.28518 4.24583 6.87867 4.68342 7.31626C5.121 7.75384 5.71449 7.99967 6.33333 7.99967H9.66667C10.2855 7.99967 10.879 8.24551 11.3166 8.68309C11.7542 9.12068 12 9.71417 12 10.333C12 10.9518 11.7542 11.5453 11.3166 11.9829C10.879 12.4205 10.2855 12.6663 9.66667 12.6663H4"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 2V6.66667C4 7.72753 4.42143 8.74495 5.17157 9.49509C5.92172 10.2452 6.93913 10.6667 8 10.6667C9.06087 10.6667 10.0783 10.2452 10.8284 9.49509C11.5786 8.74495 12 7.72753 12 6.66667V2"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.66675 14H13.3334"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
            v-if="false"
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.33325 4H13.9999"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.33325 8H13.9999"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.33325 12H13.9999"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 4H2.00667"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 8H2.00667"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 12H2.00667"
              stroke="#B3C2CB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </editor-menu-bar>
    <editor-content
      :class="`editor__content editor__content-${contentSize}`"
      :editor="editor"
      @change="handleEditorChange"
    />
    <span v-if="maxLength" class="counter">{{ lengthContent }}/300</span>
  </div>
</template>

<script>
//import Icon from "../editorIcon";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import CharacterCount from "@tiptap/extension-character-count";
import {
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
  Strike,
  Placeholder
} from "tiptap-extensions";

export default {
  name: "EditorTipTap",
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    type: {
      type: String,
      default: "doc"
    },
    content: {
      type: [Array, String],
      default: () => []
    },
    editable: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: null
    },
    clear: {
      type: Boolean,
      default: false
    },
    contentSize: {
      type: String,
      default: "sm"
    }
  },
  data() {
    return {
      editor: null,
      testContent: [
        {
          type: "paragraph",
          content: [
            {
              type: "text",
              text: "Example "
            },
            {
              type: "text",
              marks: [
                {
                  type: "bold"
                }
              ],
              text: "Text"
            }
          ]
        }
      ]
    };
  },
  computed: {
    docContent() {
      return this.content &&
        Array.isArray(this.content) &&
        this.content.length > 0
        ? {
            type: "doc",
            content: this.content
          }
        : null;
    },
    lengthContent() {
      return 20;
    }
  },
  methods: {
    handleEditorChange() {
      console.log("Editor Change");
    }
  },
  watch: {
    content(newVal, oldVal) {
      /* const isSame = this.editor.getJSON().toString() === newVal.toString();
      if (isSame) {
        return;
      }
      console.log(`Setting Content ${value}`);*/
      // this.editor.setContent(fullContent, false);
    },
    clear(value) {
      if (value) {
        this.editor.clearContent(this.content);
        this.$emit("resetClear");
      }
    },
    editable(value) {
      //this.editor.setEditable(value);
    }
  },
  mounted() {
    this.editor = new Editor({
      editable: true,
      content: this.docContent,
      extensions: [
        new BulletList(),
        new ListItem(),
        new Bold(),
        new Italic(),
        new Underline(),
        new Strike(),
        new Placeholder({
          emptyNodeClass: "is-empty",
          emptyNodeText: `Enter ${this.type} here`,
          showOnlyWhenEditable: true
        })
      ],
      onUpdate: () => {
        this.$emit("input", this.editor.getJSON());
      }
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  }
};
</script>
<style lang="scss">
.menubar {
  display: flex;
  justify-content: left;
  .menubar__button {
    border: none;
    background: none;
    svg path {
      stroke: #b3c2cb;
    }
    &.is-active svg path {
      stroke: var(--theme-color);
    }
  }
}
.editor__content {
  overflow-y: scroll;
  height: 100px;
  border: none;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
  border-radius: 12px !important;
  &::-webkit-scrollbar {
    width: 6px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator in red */
  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 0px;
  }
}

.editor__content-sm {
  height: 150px;
}

.editor__content-md {
  height: 300px;
}

.editor__content-lg {
  height: 500px;
}

.ProseMirror {
  width: 100%;
  border: none;
  border-radius: 0px;
  padding-left: 30px;
  font-family: Nunito;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #474d52;
  background: #fff;
  height: 100%;
  padding-top: 15px;
}
.editor {
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  height: 100%;
}
.editor p.is-empty:first-child::before {
  content: attr(data-empty-text);
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  float: left;
  color: #8d99a0;
  padding-left: 2px;
  pointer-events: none;
  height: 100%;
}
.counter {
  margin-top: -18px;
  margin-right: 5px;
  font-size: 12px;
  float: right;
}
</style>
